<template>
  <v-dialog
    :value="dialog"
    max-width="1200"
    scrollable
    transition="dialog-bottom-transition"
    overlay-opacity="0.6"
    @input="onDialogInput"
  >
    <v-card
      elevation="3"
      rounded="lg"
    >
      <v-toolbar
        flat
        dense
        color="color_green"
        dark
      >
        <v-toolbar-title class="text-subtitle-2">
          Distribution — {{ username }}
          <span
            v-if="breakdown"
            class="text-caption ml-2"
          >({{ breakdown.total_calls.toLocaleString('it-IT') }} calls)</span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <div
          v-if="loading"
          class="d-flex justify-center pa-6"
        >
          <v-progress-circular
            indeterminate
            color="color_green"
          />
        </div>
        <v-row
          v-else-if="breakdown"
          dense
        >
          <v-col
            v-for="section in sections"
            :key="section.key"
            cols="12"
            sm="6"
            md="3"
          >
            <div class="text-subtitle-2 mb-2">
              {{ section.title }}
            </div>
            <service-breakdown-list
              :items="breakdown[section.key]"
              :empty-label="section.emptyLabel"
            />
          </v-col>
        </v-row>
        <div
          v-else-if="!loading"
          class="text-caption grey--text pa-4"
        >
          No breakdown data
        </div>

        <!-- ── Daily calls ── -->
        <v-divider class="my-4" />

        <div class="text-subtitle-2 mb-3">
          Daily calls
        </div>

        <daily-sparkline
          :items="dailyStats"
          :year="year"
          :username="username"
          :loading="loadingDailyStats"
        />

        <v-data-table
          :headers="dailyHeaders"
          :items="dailyStats"
          :loading="loadingDailyStats"
          dense
          hide-default-footer
          :items-per-page="-1"
          class="daily-calls-table mt-3"
        >
          <template #item.call_count="{ item }">
            <span class="font-weight-bold">{{ item.call_count.toLocaleString('it-IT') }}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CallerBreakdownPanel',
  components: {
    ServiceBreakdownList: () => import('@/components/statistics/ServiceBreakdownList'),
    DailySparkline: () => import('@/components/statistics/DailySparkline')
  },
  props: {
    breakdown: { type: Object, default: null },
    username: { type: String, required: true },
    loading: { type: Boolean, default: false },
    dailyStats: { type: Array, default: () => [] },
    loadingDailyStats: { type: Boolean, default: false },
    year: { type: Number, required: true }
  },
  data() {
    return {
      dialog: true,
      sections: [
        { key: 'services', title: 'Services', emptyLabel: 'No service data' },
        { key: 'workspaces', title: 'Workspaces', emptyLabel: 'No workspace data' },
        { key: 'layers', title: 'Layers', emptyLabel: 'No layer data' },
        { key: 'time_durations', title: 'Request span', emptyLabel: 'No time range data' }
      ],
      dailyHeaders: [
        { text: 'Day', value: 'day' },
        { text: 'Calls', value: 'call_count', align: 'end', width: 100 }
      ]
    };
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit('close');
    },
    onDialogInput(value) {
      if (!value) {
        this.close();
      }
    }
  }
};
</script>

<style scoped>
.daily-calls-table {
  max-height: 280px;
  overflow-y: auto;
}
</style>
